import { render, staticRenderFns } from "./ControlOnStock.vue?vue&type=template&id=634f78cc&scoped=true"
import script from "./ControlOnStock.vue?vue&type=script&lang=js"
export * from "./ControlOnStock.vue?vue&type=script&lang=js"
import style0 from "./ControlOnStock.vue?vue&type=style&index=0&id=634f78cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634f78cc",
  null
  
)

export default component.exports